import React from 'react';
import { Container, Box } from '@mui/material';
import Footer from '../Footer/Footer';

const LoginTemplate = (props) => {
    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                background: 'linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%)',
            }}
        >
            {/* Banner at the top with full width */}
            {props.banner && (
                <Box sx={{ width: '100%' }}>
                    {props.banner}
                </Box>
            )}
            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    py: { xs: 4, sm: 6 },
                    px: { xs: 2, sm: 3 },
                }}
            >
                <Container maxWidth="sm" sx={{ display: 'flex', justifyContent: 'center' }}>
                    {props.content}
                </Container>
            </Box>
            <Footer />
        </Box>
    );
};

export default LoginTemplate;